import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { usePanelContext } from '~/eds/src/components/Panel/PanelContext';
import { useCanEditEntityGroups } from '~/hooks/useCanEditEntityGroups';
import { BatchAddGroupNodeItem } from '~/redux/api/methods/group-nodes/types';

import {
  AddToGroupPanel,
  AddToGroupPanelId,
} from '../AddToGroupButton/AddToGroupPanel';

const messages = defineMessages({
  addToGroup: {
    id: 'AddToGroup.actionLabel',
    defaultMessage: 'Add to Group',
    description: 'Action label for adding items to a group',
  },
});

export const useAddToGroup = (resourceType: 'ticket' | 'document') => {
  const { formatMessage } = useIntl();
  const { openPanel } = usePanelContext();
  const { hasPermission: canAddToGroup } = useCanEditEntityGroups();

  const [preselectedItems, setPreselectedItems] = useState<
    BatchAddGroupNodeItem[]
  >([]);

  const open = (items: BatchAddGroupNodeItem[]) => {
    setPreselectedItems(items);
    openPanel(AddToGroupPanelId);
  };

  const addToGroupBulkAction = (selectedRowIds: string[]) => ({
    label: formatMessage(messages.addToGroup),
    onClick: () =>
      open(
        selectedRowIds.map((id) => ({
          resourceType,
          resourceId: id,
        })),
      ),
  });

  const addToGroupRowAction = {
    label: formatMessage(messages.addToGroup),
    onClick: (row: { id: string }) =>
      open([{ resourceType, resourceId: row.id }]),
  };

  const panel = canAddToGroup ? (
    <AddToGroupPanel preselectedItems={preselectedItems} />
  ) : null;

  return {
    panel,
    addToGroupBulkAction,
    addToGroupRowAction,
    canAddToGroup,
    open,
  };
};
